// French strings of the tasks board (Kanban, route #/taches; registered at module load, see
// docs/UI-CONTRACT.md §7).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'kb.title': 'Tableau des tâches',
  'kb.eyebrow': 'TÂCHES',
  'kb.floor': 'Étage',
  'kb.floorAll': 'Tout le bureau',
  'kb.floorCurrent': 'Étage actuel · {name}',
  'kb.depts': 'Filtrer par service',
  'kb.deptAll': 'Tous les services',
  'kb.period': 'Période',
  'kb.period.1': '24 H',
  'kb.period.7': '7 JOURS',
  'kb.period.30': '30 JOURS',
  'kb.periodHint': 'Le travail terminé, en erreur ou ignoré des {days} derniers jours ; ce qui est à faire, en cours ou à valider, toujours.',
  'kb.hint': 'Glissez une carte d’une colonne à l’autre, ou passez par son menu (•••).',
  'kb.columnsNav': 'Aller à une colonne',
  'kb.boardLabel': 'Colonnes des tâches',
  'kb.loading': 'Chargement du tableau…',
  'kb.error': 'Le tableau n’a pas pu être chargé.',
  'kb.retry': 'Réessayer',
  'kb.unavailable': 'Le tableau des tâches n’est pas encore disponible sur ce serveur.',
  'kb.summary': { one: '{n} tâche', other: '{n} tâches' },
  'kb.summaryErrors': { one: '{n} en erreur', other: '{n} en erreur' },
  'kb.summaryNone': 'aucune erreur',

  // Columns
  'kb.col.todo': 'À faire',
  'kb.col.doing': 'En cours',
  'kb.col.review': 'À valider',
  'kb.col.blocked': 'Bloquées',
  'kb.col.failed': 'En erreur',
  'kb.col.done': 'Terminées',
  'kb.col.ignored': 'Ignorées',
  'kb.hint.todo': 'Programmées ou en file d’attente',
  'kb.hint.doing': 'Un agent y travaille',
  'kb.hint.review': 'Brouillons et décisions qui attendent quelqu’un',
  'kb.hint.blocked': 'Une cause extérieure a arrêté l’agent',
  'kb.hint.failed': 'Échecs à traiter : relancez ou ignorez',
  'kb.hint.done': 'Faites, échecs résolus ensuite compris',
  'kb.hint.ignored': 'Écartées : ignorées, annulées, refusées',
  'kb.empty.todo': 'Rien en attente.',
  'kb.empty.doing': 'Aucun agent au travail.',
  'kb.empty.review': 'Rien à valider.',
  'kb.empty.blocked': 'Aucun blocage.',
  'kb.empty.failed': 'Aucune erreur.',
  'kb.empty.done': 'Rien de terminé sur la période.',
  'kb.empty.ignored': 'Rien d’écarté.',
  'kb.more': { one: '+ {n} autre', other: '+ {n} autres' },
  'kb.moreAria': 'Afficher toute la colonne {column}',
  'kb.colAria': '{column} : {n} carte(s)',
  'kb.dropHere': 'Déposer ici',

  // Cards
  'kb.card.open': 'Ouvrir « {title} » ({column})',
  'kb.card.menu': 'Déplacer « {title} » vers…',
  'kb.card.routine': 'Routine « {title} »',
  'kb.card.routineAnon': 'Routine',
  'kb.card.manual': 'lancée à la main',
  'kb.card.untitled': 'Tâche sans titre',
  'kb.card.unknownAgent': 'Agent inconnu',
  'kb.time.scheduled': 'prévue {when}',
  'kb.time.queued': 'en file depuis {when}',
  'kb.time.running': 'depuis {when}',
  'kb.time.waiting': 'attend depuis {when}',
  'kb.time.justNow': 'à l’instant',
  'kb.time.finished': '{when}',
  'kb.badge.attempt': '{nth} essai',
  'kb.badge.attempts': { one: '{n} essai', other: '{n} essais' },
  'kb.badge.succeededAt': 'Réussie au {nth} essai',
  'kb.badge.earlierFailed': { one: '+ {n} échec précédent', other: '+ {n} échecs précédents' },
  'kb.badge.earlierBlocked': { one: '+ {n} blocage précédent', other: '+ {n} blocages précédents' },
  'kb.badge.earlierIgnored': { one: '+ {n} autre de la routine', other: '+ {n} autres de la routine' },
  'kb.badge.runs': { one: '{n} passage réussi', other: '{n} passages réussis' },
  'kb.badge.resolved': { one: '{n} essai raté avant', other: '{n} essais ratés avant' },
  'kb.badge.resolvedLater': 'RÉSOLUE ENSUITE',
  'kb.badge.nextTry': 'Nouvel essai {when}',
  'kb.badge.late': 'EN RETARD',
  'kb.badge.draft': 'BROUILLON',
  'kb.badge.decision': 'À RÉGLER',
  'kb.badge.cancelled': 'ANNULÉE',
  'kb.badge.rejected': 'REFUSÉE',
  'kb.badge.ignoredBy': 'Ignorée par {name}',
  'kb.badge.ignored': 'Ignorée',
  'kb.badge.settledBy': 'Réglée par {name}',
  'kb.badge.settled': 'Réglée',
  'kb.badge.scheduled': 'PROGRAMMÉE',
  'kb.badge.executing': 'EXÉCUTION',
  'kb.line.draft': 'Un brouillon attend votre validation.',
  'kb.line.idle': 'Rien à faire à ce passage.',

  // Moves (drag & drop and the « Déplacer vers… » menu)
  'kb.menu.title': 'Déplacer vers…',
  'kb.menu.open': 'Ouvrir la tâche',
  'kb.menu.none': 'Aucun déplacement possible',
  'kb.move.retry': '{column} — relancer',
  'kb.move.ignore': '{column} — ne plus compter comme erreur',
  'kb.move.ignoreDraft': '{column} — mettre le brouillon de côté',
  'kb.move.ignoreDecision': '{column} — ne pas donner suite',
  'kb.move.cancel': '{column} — annuler la tâche',
  'kb.move.cancelRunning': '{column} — arrêter et annuler',
  'kb.move.unignore': '{column} — ne plus ignorer',
  'kb.move.settle': '{column} — marquer réglée',
  'kb.move.chain': { one: '(et {n} autre de la routine)', other: '(et {n} autres de la routine)' },
  'kb.move.notAllowed': 'Cette carte ne peut pas aller dans « {column} ».',
  'kb.move.noRight': 'Vous ne pouvez pas agir sur les tâches de ce service.',
  'kb.done.retry': 'Relancée : la tâche repart dans « À faire ».',
  'kb.done.ignore': { one: 'Ignorée : elle ne compte plus comme une erreur.', other: '{n} tâches ignorées : elles ne comptent plus comme des erreurs.' },
  'kb.done.ignoreDraft': 'Brouillon mis de côté.',
  'kb.done.unignore': { one: 'N’est plus ignorée.', other: '{n} tâches ne sont plus ignorées.' },
  'kb.done.cancel': 'Tâche annulée.',
  'kb.done.settle': 'Marquée réglée.',
  'kb.undo': 'Annuler',
  'kb.confirm.cancelRunning.title': 'Arrêter cette tâche ?',
  'kb.confirm.cancelRunning.text': 'L’agent est en train d’y travailler : son exécution est arrêtée et la tâche est annulée. Vous pourrez la relancer depuis « Ignorées ».',
  'kb.confirm.cancelRunning.ok': 'Arrêter et annuler',
  'kb.confirm.keep': 'Laisser tourner',
});
